module.exports = __webpack_public_path__ + "img/97.2ef6b6b5.webp";